var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAda = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0033AD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.4,248.9c-1,17.9,12.8,33.2,30.7,34.3c0.6,0,1.3,0,1.9,0c18,0,32.6-14.6,32.5-32.6 c0-18-14.6-32.6-32.6-32.5C156.6,218.1,142.3,231.6,141.4,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,240.5c-5.8-0.4-10.8,4.1-11.1,9.9s4.1,10.8,9.9,11.1c5.8,0.4,10.7-4.1,11.1-9.9 C30.4,245.8,25.9,240.9,20.1,240.5L20.1,240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.4,60.1c5.2-2.6,7.2-9,4.6-14.2s-9-7.2-14.2-4.6c-5.2,2.6-7.2,8.9-4.6,14 C127.8,60.6,134.1,62.8,139.4,60.1C139.2,60.1,139.4,60.1,139.4,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,117.6c8-4,11.2-13.8,7.2-21.8s-13.8-11.2-21.8-7.2c-8,4-11.2,13.8-7.2,21.8 C154.5,118.4,164.3,121.6,172.3,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,157.2c6.2,4,14.4,2.3,18.5-3.9c4-6.2,2.3-14.4-3.9-18.5c-6.2-4-14.4-2.3-18.5,3.9l0,0 C53.3,144.8,55.1,153.2,61.3,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,234.7c-9-0.5-16.6,6.3-17.1,15.3c-0.5,9,6.3,16.6,15.3,17.1c9,0.5,16.6-6.3,17.1-15.3l0,0 C96.8,243,90,235.2,81,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,343.8c-6.6,3.3-9.3,11.3-5.9,18c3.3,6.6,11.3,9.3,18,5.9c6.6-3.3,9.3-11.3,5.9-18l0,0 C77.8,343.2,69.7,340.5,63.1,343.8L63.1,343.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.2,201.1c8.9,5.8,20.7,3.3,26.4-5.5c5.8-8.9,3.3-20.7-5.5-26.4c-8.9-5.8-20.7-3.3-26.4,5.5 C114.9,183.5,117.3,195.3,126.2,201.1L126.2,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,116.4c7.5,4.9,17.6,2.8,22.5-4.6s2.8-17.6-4.6-22.5c-7.5-4.9-17.6-2.8-22.5,4.6l0,0 C316.8,101.4,318.9,111.5,326.5,116.4L326.5,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.7,59c4.9,3.2,11.3,1.8,14.6-3.1c3.2-4.9,1.8-11.3-3.1-14.6s-11.3-1.8-14.6,3 C353.5,49.3,355,55.8,359.7,59L359.7,59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.9,217.9c-17.9-1-33.4,12.8-34.3,30.7c-1,17.9,12.8,33.4,30.7,34.3c0.6,0,1.3,0,1.8,0 c17.9,0,32.5-14.6,32.5-32.6C359.7,233,346.2,218.8,328.9,217.9L328.9,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183,198.8c5.5,10.9,16.7,17.9,29.1,17.9c17.9,0,32.5-14.6,32.5-32.6c0-5-1.2-10-3.5-14.7 c-8.1-16.1-27.7-22.5-43.7-14.4C181.3,163.2,174.9,182.8,183,198.8L183,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.9,157.2c6.6-3.3,9.1-11.5,5.8-18c-3.3-6.6-11.5-9.1-18-5.8s-9.1,11.3-5.9,17.9 C423.2,157.8,431.2,160.5,437.9,157.2L437.9,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.5,167.5c-9.4,4.8-13.3,16.2-8.5,25.6c4.8,9.4,16.2,13.3,25.6,8.5c9.4-4.8,13.3-16.2,8.5-25.6 C376.3,166.6,364.9,162.9,355.5,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.2,54.2c7.3,0.4,13.7-5.3,14.2-12.6s-5.3-13.7-12.6-14.2c-7.3-0.4-13.7,5.2-14.2,12.5 C236.2,47.3,241.9,53.6,249.2,54.2L249.2,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.1,138.3c10.6,0.6,19.6-7.5,20.1-18c0.6-10.6-7.5-19.6-18-20.1c-10.6-0.6-19.6,7.5-20.1,18 S238.5,137.7,249.1,138.3L249.1,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.5,333.5c9.4-4.8,13.3-16.2,8.5-25.6c-4.8-9.4-16.2-13.3-25.6-8.5c-9.4,4.8-13.3,16.2-8.5,25.6 C124.7,334.4,136.1,338.3,145.5,333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.4,166.2c-9.8,15.1-5.7,35.2,9.4,44.9c15.1,9.8,35.2,5.7,44.9-9.4c9.8-15.1,5.7-35.2-9.4-44.9 c-5.3-3.5-11.5-5.3-17.8-5.3C277.7,151.5,267.5,157.1,261.4,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318,302.2c-8.1-16.1-27.7-22.5-43.7-14.4c-16.1,8.1-22.5,27.7-14.4,43.7c8.1,16.1,27.7,22.5,43.7,14.4l0,0 c16-8,22.5-27.3,14.6-43.4C318.1,302.3,318.1,302.3,318,302.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.8,299.9c-8.9-5.8-20.7-3.3-26.4,5.5c-5.8,8.9-3.3,20.7,5.5,26.4c8.9,5.8,20.7,3.3,26.4-5.5 C386.1,317.5,383.7,305.7,374.8,299.9L374.8,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.1,251.1c0.5-9-6.3-16.6-15.3-17.1c-9-0.5-16.6,6.3-17.1,15.3c-0.5,9,6.3,16.6,15.3,17.1l0,0 C428.9,266.9,436.6,260,437.1,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.1,239.5c-5.8-0.4-10.8,4.1-11.1,9.9c-0.3,5.8,4.1,10.8,9.9,11.1c5.8,0.4,10.7-4.1,11.1-9.9 C492.2,244.8,487.9,239.9,482.1,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.7,343.8c-6.2-4-14.4-2.3-18.5,3.9c-4,6.2-2.3,14.4,3.9,18.5c6.2,4,14.4,2.3,18.5-3.9 C447.7,356.2,445.9,347.8,439.7,343.8L439.7,343.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.2,442c-4.9-3.2-11.3-1.8-14.6,3c-3.2,4.9-1.8,11.3,3,14.6c4.9,3.2,11.3,1.8,14.6-3l0,0 C147.5,451.7,146,445.2,141.2,442z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.6,440.9c-5.2,2.6-7.2,9-4.6,14.2c2.6,5.2,9,7.2,14.2,4.6c5.2-2.6,7.2-8.9,4.6-14 C373.2,440.4,366.9,438.2,361.6,440.9C361.8,440.9,361.6,440.9,361.6,440.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.6,334.8c9.8-15.1,5.7-35.2-9.4-45.1c-15.1-9.8-35.2-5.7-45.1,9.4c-9.9,15.1-5.7,35.2,9.4,45.1 c5.3,3.5,11.5,5.3,17.8,5.3C223.3,349.6,233.5,344.1,239.6,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,384.6c-7.5-4.9-17.6-2.8-22.5,4.6c-4.9,7.5-2.8,17.6,4.6,22.5s17.6,2.8,22.5-4.6l0,0 C184.2,399.7,182.1,389.5,174.5,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.4,446.8c-7.3-0.4-13.7,5.3-14.2,12.6s5.3,13.7,12.6,14.2c7.3,0.4,13.7-5.2,14.2-12.5 C263.4,453.7,257.7,447.4,250.4,446.8L250.4,446.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.5,362.7c-10.6-0.6-19.6,7.5-20.1,18c-0.6,10.6,7.5,19.6,18,20.1c10.6,0.5,19.6-7.5,20.1-18 C269.2,372.4,261.1,363.3,250.5,362.7L250.5,362.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.7,383.4c-8,4.1-11.2,13.9-7.1,21.9c4.1,8,13.9,11.2,21.9,7.1c8-4,11.2-13.8,7.2-21.8 C346.6,382.6,336.8,379.2,328.7,383.4L328.7,383.4z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAda);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ADA.b3a3de815110451ca795eac655f569bc.svg";